import { Accordion, AccordionSummary, Switch, Typography } from '@mui/material';
import { Box } from '@mui/system';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { GenericProductDto, PricingQuoteDetailsDto, PricingQuoteIncludedProductDto, ProductTypeEnum } from '@inosio/payments-sdk';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { selectOnboardingApplicationState, buildPricingQuoteDto } from '../../../pmui/onboarding/sagas/pmonboardingSlice';
import { calculateCostFromTiers } from '../../../shared/util/calculators';
import { ProductPreferencesProps } from '../../interfaces/ProductPreferenceInterface';

const MaintenancePreferences = (props: ProductPreferencesProps) => {
  const dispatch = useDispatch();
  const availableMaintenanceProduct = props.availableProducts[0] as GenericProductDto; //theres always only for now
  const selectOnboardingState = useSelector(selectOnboardingApplicationState);
  const existingSelectedProducts = selectOnboardingState.PricingQuoteSetupObj.IncludedProducts || [];
  const existingSelectedMaintenanceProduct = existingSelectedProducts.find((product) => product.ProductUuid === availableMaintenanceProduct.ProductUuid);

  //local states
  const [isMaintenanceSelected, setIsMaintenanceSelected] = useState(false);

  //useffects

  /**
   * This useffect listens for changes in the isMaintenanceSelected (whether product is removed or added) state.
   * It then makes changes to the PricingQuoteSetupObj based on this state.
   */
  useEffect(() => {
    let updatedSelectedProducts = [...existingSelectedProducts];

    if (isMaintenanceSelected) {
      //if the prerequisite products are not on then turn them on first
      props.preRequisiteProducts.forEach((prereq) => {
        const existingSelectedProduct = selectOnboardingState.PricingQuoteSetupObj.IncludedProducts.find((prod) => prod.ProductUuid === prereq.ProductUuid && prod.ProductType === prereq.ProductType);
        if (!existingSelectedProduct) {
          updatedSelectedProducts.push({
            ProductUuid: prereq.ProductUuid,
            ProductType: prereq.ProductType,
          } as PricingQuoteIncludedProductDto);
        }
      });

      // Add the maintenance product if available
      if (!!availableMaintenanceProduct) {
        const maintenanceProduct: PricingQuoteIncludedProductDto = {
          ProductUuid: availableMaintenanceProduct.ProductUuid,
          ProductType: ProductTypeEnum.Maintenance,
          FlatFee: calculateCostFromTiers(availableMaintenanceProduct.FlatFeeTiers || [], props.doorCount || 0),
          ProductLabel: 'Maintenance Coordination',
        };
        //first check if its already been selected, if yes then replace it
        if (!!existingSelectedMaintenanceProduct) {
          // Replace the existing product with the selected one
          updatedSelectedProducts = existingSelectedProducts.map((prod) => (prod.ProductUuid === availableMaintenanceProduct.ProductUuid ? maintenanceProduct : prod));
        } else {
          // Add the selected  product
          updatedSelectedProducts.push(maintenanceProduct);
        }
      }
    } else {
      // Remove all maintenance related products if maintenance is not selected
      updatedSelectedProducts = updatedSelectedProducts.filter((product) => product.ProductType !== ProductTypeEnum.Maintenance);
    }

    dispatch({
      type: buildPricingQuoteDto.type,
      payload: {
        IncludedProducts: updatedSelectedProducts,
      } as PricingQuoteDetailsDto,
    });
  }, [isMaintenanceSelected]);

  /**
   * This useffect listens for any changes in our master obj and checks if maintenance has been added.
   * If it has then it turns on the toggle other turns it off. Useful when turning off/on any other product causes this product to turn on/off
   */
  useEffect(() => {
    if (!!existingSelectedMaintenanceProduct) {
      setIsMaintenanceSelected(true);
    } else {
      setIsMaintenanceSelected(false);
    }
  }, [selectOnboardingState.PricingQuoteSetupObj]);

  return (
    <Accordion sx={{ marginTop: 2 }} elevation={0}>
      <AccordionSummary expandIcon={<ExpandMoreIcon />} sx={{ marginTop: 2, boxShadow: 'none', '& .MuiPaper-root': { boxShadow: 'none' } }}>
        <Box sx={{ width: '100%', display: 'flex', alignItems: 'center' }}>
          <Switch
            checked={isMaintenanceSelected}
            onChange={(e) => {
              if (props.isCustomMode) {
                setIsMaintenanceSelected(e.target.checked);
              }
            }}
          />
          <Typography sx={{ fontFamily: 'Work Sans !important', fontWeight: 600, fontSize: 'large' }}>Maintenance</Typography>
        </Box>
      </AccordionSummary>
    </Accordion>
  );
};

export default MaintenancePreferences;
